var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var OPEN_MODAL_EVENT = "openAuthModal";
export var CLOSE_MODAL_EVENT = "closeAuthModal";
export var openModal = function (additionalProps) {
    return window.dispatchEvent(new CustomEvent(OPEN_MODAL_EVENT, {
        detail: __assign({}, additionalProps)
    }));
};
export var closeModal = function () {
    return window.dispatchEvent(new CustomEvent(CLOSE_MODAL_EVENT));
};
